import { ListItem, Box, AHText, AHIcon } from "arkh";
import React from "react";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import { OrgStoreWorkspaceBreadcrumbsWithoutExternalId } from "../../OrgStores/OrgStoreWorkspaceBreadcrumbs";
import { OrgMobileDeviceListItem_device$key } from "./__generated__/OrgMobileDeviceListItem_device.graphql";
import { useIntlTokens } from "../../../../components/mobile/useIntlTokens";

export function OrgMobileDeviceListItem(props: {
  isLast: boolean;
  device: OrgMobileDeviceListItem_device$key;
}) {
  const intl_tokens = useIntlTokens();
  const device = useFragment(
    graphql`
      fragment OrgMobileDeviceListItem_device on SharedMobileDevice {
        name
        lastUsedAtDate {
          storeFormattedDate(style: DATE_ONLY)
        }
        lastIP
        lastIPConformsToCIDR
        teams {
          id
          name
        }

        store {
          name
          ...OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store
        }
      }
    `,
    props.device
  );

  return (
    <ListItem isLast={props.isLast} border="border-primary" displayMode="TABLE">
      <Box style={{ flexDirection: "row", flex: 1, alignItems: "center" }}>
        {/* Status column */}
        <Box style={{ width: "35%" }}>
          {device.lastUsedAtDate && (
            <AHText type="detail" color="text-secondary">
              {intl_tokens.LastSeen}: {device.lastUsedAtDate.storeFormattedDate}
            </AHText>
          )}
          {device.lastIP && (
            <Box
              style={{
                flexDirection: "row",
                flexWrap: "wrap",
                alignItems: "center",
              }}
              spaceTop="xsmall"
              gap="small"
            >
              <AHText type="detail" color="text-secondary">
                {intl_tokens.LastIP}: {device.lastIP}
              </AHText>
              {device.lastIPConformsToCIDR === true && (
                <AHIcon type="check" size="xsmall" color="positive" />
              )}
              {device.lastIPConformsToCIDR === false && (
                <AHIcon type="info" size="xsmall" color="negative" />
              )}
            </Box>
          )}
        </Box>
        {/* Name column */}
        <Box style={{ width: "35%" }}>
          <ListItem.Title>{device.name}</ListItem.Title>
          {device.teams && device.teams.length > 0 && (
            <Box
              style={{
                flexDirection: "row",
                flexWrap: "wrap",
                alignItems: "center",
              }}
              spaceTop="xsmall"
              gap="small"
            >
              {device.teams.map((t) => (
                <Box
                  cornerRadius="medium"
                  key={t.id}
                  borderColor="border-primary"
                  style={{
                    borderWidth: 1,
                  }}
                  spaceHorizontal="small"
                  spaceVertical="xxsmall"
                >
                  <AHText type="detail">{t.name}</AHText>
                </Box>
              ))}
            </Box>
          )}
        </Box>
        {/* Store & Workspaces column */}
        <Box style={{ flex: 1, alignItems: "flex-end" }}>
          <ListItem.SubTitle>{device.store?.name}</ListItem.SubTitle>
          {device.store && (
            <AHText type="detail">
              <OrgStoreWorkspaceBreadcrumbsWithoutExternalId
                store={device.store}
              />
            </AHText>
          )}
        </Box>
      </Box>
    </ListItem>
  );
}
